import React, { memo } from 'react'

// Libraries
import { Link } from 'react-router-dom'
import { Row } from 'react-bootstrap'
import { PropTypes } from "prop-types";
import { m } from "framer-motion"

// Data
import { serviceData1 } from './ServicesData'

// css
import "../../Assets/scss/components/_services.scss"
import { ParagraphComp } from '../ParagraphComp/ParagraphComp';

const Services = (props) => {
    return (
        <Row className={props.grid}>
            {
                props.data.map((item, i) => {
                    return (
                        <m.div 
                        key={i} 
                        className={`col px-[15px]${props.className ? ` ${props.className}` : ""}`} 
                        {...{ ...props.animation, transition: { delay: i * props.animationDelay } }}
                        >
                            <div className={`${props.theme} h-full flex flex-col`}>
                                <div className="img-wrapper flex h-[240px] bg-[#ede7e7] items-center justify-center w-[100%] relative">
                                {props.theme === "service-style-05" && <span className="text-xmd">{i + 1 >= 10 ? '' : '0'}{i + 1}</span>}
                                <div className='absolute -top-4 p-2 bg-white rounded-md shadow-xl border-2 border-gray-300'>
                                    <p className='m-0 p-0 leading-3 font-semibold text-black'>{item.title}</p>
                                </div>
                                {item.img && <img className="" src={item.img} alt="service-style-5" />}
                                {props.theme === "service-style-01" && <div className='services-box-hover'>
                                    {(item.icon || item.link) && <Link aria-label="services" to={item.link ? item.link : "#"}><i className={item.icon}></i></Link>}
                                </div>}
                                </div>
                                <div className='service-style flex-grow flex flex-col justify-between'>
                                <div className='content-section'>
                                    {props.theme === "service-style-03" && <span className='verticalline'></span>}
                                    {item.name && <span className="title font-bold text-black block font-serif mb-[10px] leading-7">{item.name}</span>}
                                    {item.content && <p className='text-black font-serif max-sm:text-lg leading-7 whitespace-pre-line'>{item.content}</p>}
                                </div>
                                {item.link && (props.theme === "service-style-02" || props.theme === "service-style-05") && <div className='pt-3 info-service  mt-auto'>
                                    {(item.linkTitle || item.icon) && <Link aria-label="services" to={item.link ? item.link : "#"} className="ServicesLinkHOver no-underline font-bold text-sm uppercase block">
                                    <p className='text-white p-0 m-0'>.</p>
                                    <div className='flex gap-2 items-center'>
                                        <Link className="text-1xl font-bold mb-0" to={{
                                            pathname: item.link,
                                            hash: item.id ? `#${item.id}` : ''
                                        }} >
                                            {item.linkTitle}
                                        </Link>
                                        <i className={item.icon}></i>
                                    </div>
                                    </Link>}
                                </div>}
                                {item.anchor && (props.theme === "service-style-02" || props.theme === "service-style-05") && <div className='pt-3 info-service  mt-auto'>
                                    {(item.linkTitle || item.icon) && <div aria-label="services" className="ServicesLinkHOver no-underline font-bold text-sm uppercase flex justify-between">
                                    <p className='text-white p-0 m-0'>.</p>
                                    <div className='flex gap-2 items-center'>
                                        <a className="text-1xl font-bold mb-0" 
                                            href={item.anchor} target='_blank' rel='noreferrer'
                                        >
                                            {item.linkTitle}
                                        </a>
                                        <i className={item.icon}></i>
                                    </div>
                                    </div>}
                                </div>}
                                </div>
                            </div>
                        </m.div>
                    )
                })
            }
        </Row>
    )
}

Services.defaultProps = {
    data: serviceData1,
    theme: "service-style-01",
    animationDelay: 0.2
}

Services.propTypes = {
    grid: PropTypes.string,
    theme: PropTypes.string,
    animationDelay: PropTypes.number,
    animation: PropTypes.object,
    data: PropTypes.arrayOf(
        PropTypes.exact({
            icon: PropTypes.string,
            title: PropTypes.string,
            img: PropTypes.string,
            content: PropTypes.string,
            link: PropTypes.string,
            linkTitle: PropTypes.string,
        })
    ),
}


export default memo(Services)